import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import RowActions, { type RowAction } from '../../../../components/RowActions';
import type { SettingsSiteRow } from '../../types';
import { SITE_ROW_LABELS as LABELS } from '../../../../utils/labels';

interface SiteRowProps {
  site: SettingsSiteRow;
  showDivider: boolean;
  onEdit?: () => void;
  onArchive?: () => void;
  onUnarchive?: () => void;
  onDelete?: () => void;
}

export default function SiteRow({
  site,
  showDivider,
  onEdit,
  onArchive,
  onUnarchive,
  onDelete,
}: SiteRowProps) {
  const actions: RowAction[] = site.archived
    ? onUnarchive
      ? [{ label: LABELS.unarchiveSite, icon: <UnarchiveOutlinedIcon fontSize="small" />, onClick: onUnarchive, color: 'success', testId: 'unarchive-button' }]
      : []
    : [
        ...(onEdit ? [{ label: LABELS.editSite, icon: <EditIcon fontSize="small" />, onClick: onEdit, color: 'primary' as const, testId: 'edit-button' }] : []),
        ...(site.has_bookings
          ? onArchive
            ? [{ label: LABELS.archiveSite, icon: <ArchiveOutlinedIcon fontSize="small" />, onClick: onArchive, color: 'warning' as const, testId: 'archive-button' }]
            : []
          : onDelete
            ? [{ label: LABELS.deleteSite, icon: <DeleteOutlineIcon fontSize="small" />, onClick: onDelete, color: 'error' as const, testId: 'delete-button' }]
            : []),
      ];

  return (
    <div>
      {showDivider && <hr className="border-border-subtle" />}
      <div className="flex items-center gap-3 px-4 py-3">
        <span className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: site.color }} />
        <div className="flex-1 min-w-0">
          <p className={`font-medium mb-0 mt-0 truncate ${site.archived ? 'text-text-secondary' : ''}`}>
            {site.name}
          </p>
          <p className="text-xs mb-0 mt-0 text-text-secondary truncate">
            {site.project_name
              ? `${site.project_name} (${site.project_year})`
              : site.project_id
                ? LABELS.unknownProject
                : LABELS.allProjects}
          </p>
        </div>
        <div className="flex items-center gap-1 shrink-0">
          <RowActions actions={actions} />
        </div>
      </div>
    </div>
  );
}
